const myYelpApiKey = "PuHnd64Dd9CvVzeh4sjMt8EqXqKm8_AR7EH3-UX4JWtRdLPmhvonwsUnRIZFo2mvPfrTCzxkPPbd3Mu_n3nNVPi8jv6_UErl6gcC483owrla3LFwmm9IHo1JomrpZHYx";

const getYelpBusinessInfo = async (city, term) => {
    const yelpApiUrl = 'https://cors-anywhere.herokuapp.com/https://api.yelp.com/v3/businesses/search';
    try {
        const buildUrl = `${yelpApiUrl}?location=${city}&term=${term}`
        const response = await fetch(buildUrl, {
            method: 'GET',
            headers: {
                accept: 'application/json',
                Authorization: `Bearer ${myYelpApiKey}`
            }
        });
        const data = await response.json();

        // Check if the response contains the "businesses" property
        if (data.businesses) {
            return data.businesses; // Return the array of businesses
        } else {
            return []; // Return an empty array if no businesses found
        }
    } catch (error) {
        return 'Error from Yelp'
    }
}


// getYelpBusinessInfo('burnaby', 'french')

// async function reviewFetchedData() {
//     const results = await getYelpBusinessInfo('vancouver', 'sushi');
//     console.log(results);
// }
//
// reviewFetchedData();

export default getYelpBusinessInfo;